module.exports = __webpack_public_path__ + "static/banner-one-shape8-8897819e927c277fc232099d552a43c1.png";